export default __webpack_public_path__ + "static/media/boxUnknownMb2.0fb3f170.png";